import clsx from 'clsx';
import type { ReactNode } from 'react';
import styles from './Page.module.css';

export interface PageProps {
  /** `narrow` for single forms (sign-in), `default` for lists and grids. */
  readonly width?: 'default' | 'narrow' | undefined;
  readonly children: ReactNode;
  readonly className?: string | undefined;
}

/** Main content column with page gutters and safe areas. */
export const Page = ({ width = 'default', children, className }: PageProps) => (
  <main className={clsx(styles.page, styles[width], className)}>{children}</main>
);

export interface PageHeaderProps {
  readonly title: ReactNode;
  /** Small line above the title, e.g. a back link. */
  readonly eyebrow?: ReactNode | undefined;
  readonly meta?: ReactNode | undefined;
  /** The screen's primary action (and at most a menu next to it). */
  readonly actions?: ReactNode | undefined;
}

export const PageHeader = ({ title, eyebrow, meta, actions }: PageHeaderProps) => (
  <header className={styles.header}>
    <div className={styles.heading}>
      {eyebrow && <div className={styles.eyebrow}>{eyebrow}</div>}
      <h1 className={styles.title}>{title}</h1>
      {meta && <div className={styles.meta}>{meta}</div>}
    </div>
    {actions && <div className={styles.actions}>{actions}</div>}
  </header>
);
